import Boat from 'assets/images/Boat.svg'
import { TextWithOverflow } from 'common/components/TextWithOverflow/TextWithOverflow'
import { pagesPaths } from 'common/router/routes.utils'
import { useRouter } from 'next/router'
import { userCategoryEnum } from 'services/auth/auth.enums'
import { useUserPublic } from 'services/auth/hooks/useUser'
import { ICommunityWiki } from 'services/community/wiki.types'
import styled from 'styled-components'
import { CommunityRemoveWikiButton } from './CommunityRemoveWikiButton'

interface IProps {
  item: ICommunityWiki
  refetch: () => void
}
const CommunityWikiListItem = ({ item, refetch }: IProps) => {
  const router = useRouter()
  const { data: user } = useUserPublic()

  const redirectToItem = () => {
    if (item.slug?.length)
      router.push({
        pathname: pagesPaths.communityWikiItem(item.slug[item.slug.length - 1]),
        query: { ...router.query },
      })
  }

  const isValidatorOrAdmin =
    user?.category && [(userCategoryEnum.ADMIN, userCategoryEnum.VALIDATOR)].includes(user?.category)
  return (
    <TemplateRow
      key={item.id}
      onClick={redirectToItem}
      className="grid-nogutter flex flex-wrap p-3 sm:px-3 dataview-item align-items-center"
    >
      <TextWithOverflow
        verticalRows={2}
        title={item.title}
        className="sm:col-8 col-12 sm:pl-0 pl-2 text-lg font-semibold "
      >
        {item.title}
      </TextWithOverflow>

      {item.category === 'question' && (
        <div className="sm:col-2 sm:pl-0 pl-2 flex align-items-center gap-2">
          <i className="pi pi-question-circle"></i> {item.category?.charAt(0).toUpperCase() + item.category?.slice(1)}
        </div>
      )}
      {item.category === 'news' && (
        <div className="sm:col-2 sm:pl-0 pl-2 flex align-items-center gap-2">
          <i className="pi pi-link"></i> {item.category?.charAt(0).toUpperCase() + item.category?.slice(1)}
        </div>
      )}
      {item.category === 'poll' && (
        <div className="sm:col-2 sm:pl-0 pl-2 flex align-items-center gap-2">
          <i className="pi pi-star"></i> Company review
        </div>
      )}
      {item.category === 'poll-ship' && (
        <div className="sm:col-2 sm:pl-0 pl-2 flex align-items-center gap-2">
          <Boat /> Ship review
        </div>
      )}
      <div className="sm:col-1 sm:ml-0 ml-2 flex align-items-center gap-2">
        <i className="pi pi-comments"></i> {item.numberOfComments ? item.numberOfComments : 0}
      </div>
      <div className="sm:col-1 sm:ml-0 ml-2 flex align-items-center gap-2">
        <i className="pi pi-eye"></i> {item.views ? item.views : 0}
      </div>

      {isValidatorOrAdmin && (
        <StyledRemoveButton onClick={(e) => e.stopPropagation()}>
          <CommunityRemoveWikiButton id={item.id} refetch={refetch} />
        </StyledRemoveButton>
      )}
    </TemplateRow>
  )
}

const StyledRemoveButton = styled.div`
  position: absolute;
  right: -3rem;
`

const TemplateRow = styled.div`
  position: relative;
  width: 100%;
  color: ${({ theme }) => theme.colors.black};
  cursor: pointer;

  :hover {
    background-color: ${({ theme }) => theme.colors.primary_25} !important;
  }

  .template-title {
    font-size: 18px;
    font-weight: 600;
  }
  .template-stats {
    font-size: 14px;

    > div {
      display: flex;
      gap: 5px;
      align-items: center;
    }
  }
`
export default CommunityWikiListItem
